<template>
	<div>
		<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('15')}}</div>
				<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('16')}}</div>
				<form @submit.prevent="" novalidate>
				<div class="mgt-40 pdl-24 pdr-24 position-relative">
					<label
						class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
						data-mdc-auto-init="MDCTextField"
						:class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
						id="lastNameValueEl">
						<span class="mdc-notched-outline">
							<span class="mdc-notched-outline__leading"></span>
							<span class="mdc-notched-outline__notch">
								<span class="mdc-floating-label" id="my-label-id">{{ $t('17') }}</span>
							</span>
							<span class="mdc-notched-outline__trailing"></span>
						</span>
						<input class="mdc-text-field__input" type="text"
							aria-labelledby="my-label-id"
							id="lastName"
							name="lastName"
							v-model="lastName"
							v-validate="'required'"
							ref="lastName"
							maxlength="50"
						>
						<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
							role="button">report_problem</i>
					</label>
					<div class="mdc-text-field-helper-line">
						<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
							id="my-helper-id" aria-hidden="true">
							<span v-show="submitState && lastNameInvalidCheck">
									{{$t('949')}}
											<!-- * 휴대폰 번호 또는 이메일 주소를 입력하세요. -->
							</span>
						</div>
					</div>
				</div>
				<div class="mgt-16 pdl-24 pdr-24 position-relative">
					<label
						class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
						data-mdc-auto-init="MDCTextField"
						:class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
						id="firstNameValueEl">
						<span class="mdc-notched-outline">
							<span class="mdc-notched-outline__leading"></span>
							<span class="mdc-notched-outline__notch">
								<span class="mdc-floating-label" id="my-label-id"> {{ $t('18') }}</span>
							</span>
							<span class="mdc-notched-outline__trailing"></span>
						</span>
						<input class="mdc-text-field__input" type="text"
						id="firstName"
						name="firstName"
						v-model="firstName"
						v-validate="'required'"
						ref="firstName"
						maxlength="50"
						>
						<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
							role="button">report_problem</i>
					</label>
					<div class="mdc-text-field-helper-line">
						<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
							id="my-helper-id" aria-hidden="true">
								<span v-show="submitState && firstNameInvalidCheck">
										{{$t('950')}}
								</span>
						</div>
					</div>
				</div>
				<div class="mgt-16 pdl-24 pdr-24 position-relative">
					<label
						class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
						data-mdc-auto-init="MDCTextField"
						:class="submitState && codeInvalidCheck ? 'mdc-text-field--invalid' : ''"
							id="codeValueEl">
						<span class="mdc-notched-outline">
							<span class="mdc-notched-outline__leading"></span>
							<span class="mdc-notched-outline__notch">
								<span class="mdc-floating-label" id="my-label-id">{{ $t('19') }}</span>
							</span>
							<span class="mdc-notched-outline__trailing"></span>
						</span>
						<input class="mdc-text-field__input"
							type="text"
							id="code"
							name="code"
							v-model="code"
							v-validate="'required'"
							ref="code"
							maxlength="50"
						aria-labelledby="my-label-id">
						<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
							role="button">report_problem</i>
					</label>
					<div class="mdc-text-field-helper-line">
						<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
							id="my-helper-id" aria-hidden="true">
							<span v-show="submitState && codeInvalidCheck">
									{{ $t('953') }}
							</span>
						</div>
					</div>
				</div>
				<div class="mgt-30 mgb-50 pdl-24 pdr-24">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8 b-radius4" @click="searchInfoData" @keypress="searchInfoData" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('20')}}</span>
					</button>
					<button class="mdc-button t-color-secondaryBtnText  b-radius4" @click="cancelFindCode()" @keypress="cancelFindCode()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('21')}}</span>
					</button>
				</div>
				</form>
	</div>
</template>

<script>
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import {findIdMixin} from '@/mixins/findId.js'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'

export default {

	data() {
		return {
			firstName: '',
			lastName: '',
			code: '',
			submitState: false,
			firstNameTextField: '',
			lastNameTextField: '',
			codeTextField: '',
			externalAuthCode: false,
		}
	},

	mixins: [findIdMixin],

	mounted() {
		this.setMaterialUi()
		// Store 초기화(init store)
		this.INIT_FINDPW_STORE()
		this.$refs.lastName.focus()
	},

	computed: {
		firstNameInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if(this.errors.has('firstName')) {
					returnValue = true
				} else {
					returnValue = false
				}
			}
			this.firstNameTextField.valid === !returnValue ? '' : this.firstNameTextField.valid = !returnValue
			return returnValue
		},

		lastNameInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('lastName')) {
					returnValue = true
				} else {
					returnValue = false
				}
			}
			this.lastNameTextField.valid === !returnValue ? '' : this.lastNameTextField.valid = !returnValue
			return returnValue
		},

		codeInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if(this.errors.has('code')) {
					returnValue = true
				} else {
					returnValue = false
				}
			}
			this.codeTextField.valid === !returnValue ? '' : this.codeTextField.valid = !returnValue
			return returnValue
		}
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('findId', ['SET_STEP1', 'SET_AUTH_METHODS', 'INIT_FINDPW_STORE']),

		setMaterialUi() {
		window.mdc.autoInit();
		const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
			this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameValueEl'))
			this.firstNameTextField.useNativeValidation = false

			this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameValueEl'))
			this.lastNameTextField.useNativeValidation = false

			this.codeTextField = new MDCTextField(document.querySelector('#codeValueEl'))
			this.codeTextField.useNativeValidation = false

			const buttonRipple = [].map.call(document.querySelectorAll(selector), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		// search information
		searchInfoData() {
			this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    // this.callLoginApi(loginType)
                    let params = {
                        value: '',
                        firstName: this.lastName,
                        lastName: this.firstName,
                        code: this.code,
                    }

                    let paramss = {
                        value: '',
                        firstName: this.firstName,
                        lastName: this.lastName,
                        code: this.code,
                    }

                    this.SET_STEP1(paramss)
                    // 패스워드 찾을 인증 수단 조회(get find password auth methods)
                    findApi.findByInfo(params).then((response) => {
                        let responseData = response.data.data
                        this.SET_AUTH_METHODS(responseData)
                        if (responseData.length) {
                            this.$router.push({
                                name: 'FindIdStep3'
                            })
                        }else {
                            // this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
                            findApi.findByInfo(paramss).then((response) => {
                                let responseData = response.data.data
                                this.SET_AUTH_METHODS(responseData)
                                if (responseData.length) {
                                    this.$router.push({
                                        name: 'FindIdStep3'
                                    })
                                }
                            }).catch((err) => {
                                this.$snackOpen({
                                    contents: this.$t('29') +' '+ this.$t('30'),
                                    btnDisplayYN: false
                                }).then(() => {})
                            })
                        }
                    }).catch((err) => {
                        let responseData = err.response.data.meta
                        // this.errorModal({title:'검색 결과 없음', content: '검색하신 내용을 찾을 수 없습니다. 다른 정보를 이용해 다시 검색해주세요.'}).then(() => {})
                        // this.$snackOpen({contents:'검색 결과가 없습니다. 검색하신 이메일 주소 또는 휴대폰 번호를 확인 후 다시 시도해주세요.'}).then(() => {})
                        findApi.findByInfo(paramss).then((response) => {
                                let responseData = response.data.data
                                this.SET_AUTH_METHODS(responseData)
                                if (responseData.length) {
                                    this.$router.push({
                                        name: 'FindIdStep3'
                                    })
                                }
                            }).catch((err) => {
                                this.$snackOpen({
                                    contents: this.$t('29') +' '+ this.$t('30'),
                                    btnDisplayYN: false
                                }).then(() => {})

                            })
                    })
                }
                this.$refs.lastName.focus()
            })
		}
	}
}
</script>
